export default __webpack_public_path__ + "static/media/property_1_17.e1ff16aa.webp";